const typography = {
    FEEDBACK_FORMS: "Feedback Forms",
    ADD_FEEDBACK_FORM: "Add Feedback Form",
    EDIT_FEEDBACK_FORM: "Edit Feedback Form",
    STATUS: "Status",
    QUESTION_COUNT: "Questions",
    CREATED: "Created",
    ACTION: "Action",
    ALL: "All",
    ACTIVE: "Active",
    INACTIVE: "Inactive",
    SET_ACTIVE: "Set Active",
    DELETE_FEEDBACK_FORM_CONFIRMATION_MESSAGE:
        "Are you sure you want to delete this feedback form?",
    QUESTION: "Question",
    QUESTION_TYPE: "Type",
    REQUIRED: "Required",
    ADD_QUESTION: "Add Question",
    REMOVE: "Remove",
    OPTION: "Option",
    ADD_OPTION: "Add Option",
    TEXT_ANSWER: "Text answer",
    NUMBER_ANSWER: "Number (rating)",
    OPTIONS_ANSWER: "Multiple choice",
    SAVE: "Save",
    SAVING: "Saving...",
    QUESTIONS_LOCKED_MESSAGE:
        "This form already has submitted feedback, so its questions can't be edited — create a new form instead if you need different questions. You can still change its status below.",
};

export default typography;
